module.exports = __webpack_public_path__ + "img/Support-skill-608.0b0399f4.png";